export default "__VITE_ASSET__CuOl19rF__"